module.exports = __webpack_public_path__ + "img/jf_home_01.7c5f0831.jpg";